var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonLoginV2',{attrs:{"platform":"h5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }